/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';

/**
 * Scenario content for validation
 * @export
 * @interface InternalApiScenarioContentForValidation
 */
export interface InternalApiScenarioContentForValidation {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentForValidation
     */
    content: string;
    /**
     * 
     * @type {InternalApiScenarioContentForValidationLanguageEnum}
     * @memberof InternalApiScenarioContentForValidation
     */
    language: InternalApiScenarioContentForValidationLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentForValidation
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentForValidation
     */
    logic?: string;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiScenarioContentForValidation
     */
    parameters: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioContentForValidation
     */
    segments: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioContentForValidation
     */
    excludedSegments: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScenarioContentForValidation
     */
    includeRelatedTransactions?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiScenarioContentForValidationLanguageEnum {
    SQL = 'SQL',
    JMESPATH = 'JMESPATH'
}


/**
 * Check if a given object implements the InternalApiScenarioContentForValidation interface.
 */
export function instanceOfInternalApiScenarioContentForValidation(value: object): value is InternalApiScenarioContentForValidation {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    if (!('segments' in value) || value['segments'] === undefined) return false;
    if (!('excludedSegments' in value) || value['excludedSegments'] === undefined) return false;
    return true;
}

export function InternalApiScenarioContentForValidationFromJSON(json: any): InternalApiScenarioContentForValidation {
    return InternalApiScenarioContentForValidationFromJSONTyped(json, false);
}

export function InternalApiScenarioContentForValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioContentForValidation {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'language': json['language'],
        'details': json['details'] == null ? undefined : json['details'],
        'logic': json['logic'] == null ? undefined : json['logic'],
        'parameters': ((json['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'segments': json['segments'],
        'excludedSegments': json['excludedSegments'],
        'includeRelatedTransactions': json['includeRelatedTransactions'] == null ? undefined : json['includeRelatedTransactions'],
    };
}

export function InternalApiScenarioContentForValidationToJSON(json: any): InternalApiScenarioContentForValidation {
    return InternalApiScenarioContentForValidationToJSONTyped(json, false);
}

export function InternalApiScenarioContentForValidationToJSONTyped(value?: InternalApiScenarioContentForValidation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'language': value['language'],
        'details': value['details'],
        'logic': value['logic'],
        'parameters': ((value['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'segments': value['segments'],
        'excludedSegments': value['excludedSegments'],
        'includeRelatedTransactions': value['includeRelatedTransactions'],
    };
}

